import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button, SvgIcon } from "@mui/material";
import { useWatchAsset } from "wagmi";

import { type IToken, TokenType } from "@framework/types";
import { useMetamaskValue } from "@dzambalaorg/react-hooks-eth";
import { MetaMaskIcon } from "@dzambalaorg/mui-icons";

interface IErc20AddToMetamaskButtonProps {
  token: IToken;
}

export const Erc20AddToMetamaskButton: FC<IErc20AddToMetamaskButtonProps> = props => {
  const { token } = props;
  const { watchAsset } = useWatchAsset();

  const { execute: metaFnAdd } = useMetamaskValue(async () => {
    watchAsset({
      type: "ERC20",
      options: {
        address: token.template!.contract!.address,
        symbol: token.template!.contract!.symbol,
        decimals: token.template!.contract!.decimals,
      },
    });
    return Promise.resolve(true);
  }, {});

  const handleAddToMetamask = async () => {
    await metaFnAdd();
  };

  return (
    <Button
      startIcon={<SvgIcon component={MetaMaskIcon} viewBox="0 0 60 60" />}
      variant="contained"
      onClick={handleAddToMetamask}
      disabled={token.template!.contract!.contractType !== TokenType.ERC20}
      data-testid="Erc20AddToMetamaskButton"
      fullWidth
    >
      <FormattedMessage id="form.buttons.addToMetamask" />
    </Button>
  );
};
